
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedHalfLeft as ObiSpeedHalfLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-half-left.js';
 
 
 

 
 export const ObiSpeedHalfLeft = createComponent({
   react: React,
   tagName: 'obi-speed-half-left',
   elementClass: ObiSpeedHalfLeftElement,
   events: {
     
   }
  });
 
 